import { Controller } from "@hotwired/stimulus";

export default class LoginController extends Controller {
  static targets = ["button", "form", "email"];
  static values = { posturl: String, verifyurl: String };

  initialize() {
    this.handleButtonClick = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const email = this.emailTarget?.value?.trim();
      if (!email || !this.isValidEmail(email)) {
        this.emailTarget.setCustomValidity("Please enter a valid email address");
        this.formTarget.reportValidity();
        return;
      }
      this.emailTarget.setCustomValidity("");

      if (this.hasPosturlValue) this.formTarget.action = this.posturlValue;

      // 3) Submit (fires 'submit' event, honors constraints, works with Turbo)
      this.formTarget.requestSubmit();
    };

    // Auto-clean zero-width spaces on any input change
    this.handleInput = (e) => {
      const cleaned = e.target.value.replaceAll('\u200b', '');
      if (cleaned !== e.target.value) {
        e.target.value = cleaned;
      }
    };
  }

  // Simple email validation - checks for basic pattern
  isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  connect() {
    if (this.hasFormTarget && this.hasPosturlValue) {
      this.formTarget.action = this.posturlValue;
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("click", this.handleButtonClick);
    }
    if (this.hasEmailTarget) {
      this.emailTarget.addEventListener("input", this.handleInput);
    }
  }

  disconnect() {
    if (this.hasButtonTarget) {
      this.buttonTarget.removeEventListener("click", this.handleButtonClick);
    }
    if (this.hasEmailTarget) {
      this.emailTarget.removeEventListener("input", this.handleInput);
    }
  }
}